import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'

export class FacebookRepository extends BaseRepository<null> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(null, token, cache)
    }

    async getAdsAccounts(facebookId: string, facebookToken: string) {
        const url =
            this.config.automationApiUrl +
            '/facebook/users/' +
            facebookId +
            '/accounts?fb_token=' +
            facebookToken +
            '&token=' +
            this.resolvedToken
        console.log('url', url)
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
